/**
 * ipl-teams.js — Static team constants for IPL 2026.
 *
 * 10 IPL franchise teams with code, name, city, brand color, logo path.
 * Same export shape as t20wc-teams.js for seamless tournament switching.
 */

export const TEAM_CODE_TO_ID = {
  CSK: "chennai_super_kings",
  MI: "mumbai_indians",
  RCB: "royal_challengers_bengaluru",
  KKR: "kolkata_knight_riders",
  DC: "delhi_capitals",
  PBKS: "punjab_kings",
  RR: "rajasthan_royals",
  SRH: "sunrisers_hyderabad",
  GT: "gujarat_titans",
  LSG: "lucknow_super_giants",
};

export const TEAM_ID_TO_CODE = Object.fromEntries(
  Object.entries(TEAM_CODE_TO_ID).map(([code, id]) => [id, code])
);

export const TEAM_NAMES = {
  chennai_super_kings: "Chennai Super Kings",
  mumbai_indians: "Mumbai Indians",
  royal_challengers_bengaluru: "Royal Challengers Bengaluru",
  kolkata_knight_riders: "Kolkata Knight Riders",
  delhi_capitals: "Delhi Capitals",
  punjab_kings: "Punjab Kings",
  rajasthan_royals: "Rajasthan Royals",
  sunrisers_hyderabad: "Sunrisers Hyderabad",
  gujarat_titans: "Gujarat Titans",
  lucknow_super_giants: "Lucknow Super Giants",
};

export const TEAM_COLORS = {
  chennai_super_kings: "#f9cd05",
  mumbai_indians: "#004ba0",
  royal_challengers_bengaluru: "#d4213d",
  kolkata_knight_riders: "#3a225d",
  delhi_capitals: "#004c93",
  punjab_kings: "#d71920",
  rajasthan_royals: "#ea1a85",
  sunrisers_hyderabad: "#f7682b",
  gujarat_titans: "#1c1c2b",
  lucknow_super_giants: "#00b7eb",
};

export const TEAM_CITIES = {
  chennai_super_kings: "Chennai",
  mumbai_indians: "Mumbai",
  royal_challengers_bengaluru: "Bengaluru",
  kolkata_knight_riders: "Kolkata",
  delhi_capitals: "Delhi",
  punjab_kings: "Mohali",
  rajasthan_royals: "Jaipur",
  sunrisers_hyderabad: "Hyderabad",
  gujarat_titans: "Ahmedabad",
  lucknow_super_giants: "Lucknow",
};

/**
 * Build a team display object from a team code.
 */
export function buildTeamObject(teamCode) {
  const teamId = TEAM_CODE_TO_ID[teamCode] || teamCode?.toLowerCase();
  return {
    teamId: teamId || teamCode,
    name: TEAM_NAMES[teamId] || teamCode,
    shortName: teamCode,
    sport: "cricket",
    logoUrl: null,
    color: TEAM_COLORS[teamId] || "#888888",
    // Safety net: if this object is rendered directly in JSX or used in
    // string context, display the short code instead of "[object Object]".
    toString() { return teamCode; },
  };
}
